
export interface IClock {
    getBeginningOfTodayForTimeZone(timezone: number): Date;
    getTimeTillMidnight(timezone: number): number;
}

export class Clock implements IClock {

    private readonly dateConstructor: DateConstructor;
    readonly millisecondsInMinute: number;

    constructor(dateConstructor: DateConstructor)
    {
        this.dateConstructor = dateConstructor;
        this.millisecondsInMinute = 60000;
    }

    getBeginningOfTodayForTimeZone(timezone: number)
    {
        const currentDate = new this.dateConstructor();
        const delta = this.getDifferenceBetweenCurrentTimezoneAndSelected(currentDate, timezone);
        const currentInTimezone = new Date(currentDate.getTime() + delta);
        currentInTimezone.setHours(0, 0, 0, 0);
        const target = new Date(currentInTimezone.getTime() - delta);
        return target;
    }

    getTimeTillMidnight(timezone:number) {
        const currentDate = new this.dateConstructor();
        const delta = this.getDifferenceBetweenCurrentTimezoneAndSelected(currentDate, timezone);
        const currentInTimezone = new Date(currentDate.getTime() + delta);
        const midnight = new Date(currentInTimezone);
        midnight.setDate(midnight.getDate() + 1);
        midnight.setHours(0, 0, 0, 0);
        return midnight.getTime() - currentInTimezone.getTime();
    }

    private getDifferenceBetweenCurrentTimezoneAndSelected(currentDate:Date, selectedTimezone:number)
    {
        const browserTimezoneOffset = -currentDate.getTimezoneOffset() * this.millisecondsInMinute;
        const targetTimezoneOffset = selectedTimezone * 60 * this.millisecondsInMinute;
        return targetTimezoneOffset - browserTimezoneOffset;
    }
}